import { Button, TextField } from '@mui/material'
import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import DoneIcon from '@mui/icons-material/Done';
import { addApplicableSlab, changeEditModeofSlab, deleteApplicableSlab } from '../../../../../stateManagement/actions/manageCouponActions';
import { isSlabValid, getFieldsToCheck, validateSingleSlab } from './service';
import { INVALID_RANGE_OVERLAPPING, INVALID_SLAB_FIELD, labelMappings } from '../../../utils/utils';
import { openPopup } from '../../../../../stateManagement/actions/popupActions';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCouponAlert } from '../../../context/CouponAlert';
import { APPLICABLE_SLABS_INPUTS_types, SingleSlabPropType } from '../../../types';
import { isOnlyDigit } from '../../../services/services';
import { isDecimal } from '../../../services/services';

const mappings: Record<string, any> = {
    'textField': TextField
}

function SingleSlab(props: SingleSlabPropType) {
    const { slab , inputs ,slabUnit,isAnyDataTypedRef} = props;
    const [currentSlabValues, setCurrentSlabValues] = useState<Record<string,string | boolean | number>>({...slab});
    const [errors, setErrors] = useState<Record<string,string>>({});
    const {showAlert} = useCouponAlert();
    const fieldsToCheck  = getFieldsToCheck(inputs);
            
    const isDeleteOrSaveEditUnmount = useRef<boolean>(false);

    const isLetters = (str:string) => /^[A-Za-z]*$/.test(str);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const {name , value} = e.target;  
        if(value !==null && value!==undefined && value.trim() !==""){
            isAnyDataTypedRef.current = true;
        }else{
            isAnyDataTypedRef.current = false;
        }
        let newVal;
        if(e.target.name==="coupon-description"){
             newVal = {...slab , [name]:value};
             addApplicableSlab(newVal,slab.id);
             const newErrors = validateSingleSlab({[name]:value},slab, fieldsToCheck,errors,false,slabUnit);
             setErrors(newErrors);
        }
        else if (isOnlyDigit(value)) {
             newVal = {...slab , [name]:value};
             addApplicableSlab(newVal,slab.id);
             const newErrors = validateSingleSlab({[name]:value},slab, fieldsToCheck,errors,false,slabUnit);
             setErrors(newErrors);
        }
        else if (e.target.name === "discount-offered" && isDecimal(value)) {
            newVal = {...slab , [name]:value};
            addApplicableSlab(newVal,slab.id);
            const newErrors = validateSingleSlab({[name]:value},slab, fieldsToCheck,errors,false,slabUnit);
            setErrors(newErrors);
       }
       
    }

    const handleSave = () => {
        const res = isSlabValid(errors , currentSlabValues , fieldsToCheck);
        if(res === INVALID_SLAB_FIELD){
            const newErrors = validateSingleSlab(currentSlabValues , currentSlabValues, fieldsToCheck, errors, true,slabUnit)
            setErrors(newErrors);
            return;
        }
        else if(res === INVALID_RANGE_OVERLAPPING){
            openPopup("Alert", labelMappings["APPLICABLE_SLAB_RANGE_OVERLAPPING"])
            return;
        }

        addApplicableSlab({...currentSlabValues,isEdit:false}, currentSlabValues?.id as string)
        showAlert(`Data ${currentSlabValues?.isEdit ? 'Updated' : 'Saved'}`,'success')
    }

    const handleEditClick = () => {
        changeEditModeofSlab(currentSlabValues?.id as string , true);
    }

    const handleDelete = (id:string)=>{
        isDeleteOrSaveEditUnmount.current = true;
        deleteApplicableSlab(id);
        isAnyDataTypedRef.current = false;
    }

    useEffect(()=>{
        setCurrentSlabValues({...slab})
    },[slab])
    
    return (
        <div className="applicable-single-slab-wrapper">
            <div className="applicable-single-slab-wrapper-header" style={{  }}>
                {
                    slab?.isEdit ? <Button variant='contained' className='applicable-single-slab-save-btn' size='small' startIcon={<DoneIcon />} onClick={handleSave}>{'Save'}</Button> :
                        <Button variant='contained' className='applicable-single-slab-edit-btn' size='small' startIcon={<DoneIcon />} onClick={handleEditClick}>{'Edit'}</Button>
                }

                <Button onClick={() => handleDelete(slab.id)} size='small' className='applicable-single-slab-delete-button' startIcon={<DeleteIcon />}>
                    Delete
                </Button>    
            </div>
            <div className="applicable-single-slab-wrapper-content">
                {
                    inputs.map((item:APPLICABLE_SLABS_INPUTS_types) => {
                        return <div className='applicable-slab-single-field' key={item.id} style={{ margin: '10px 0', display: 'flex', alignItems: 'baseline', gap: '5px' }}>
                            <div className="applicable-slab-single-field-left" style={{ width: '30%' }}>
                                <p style={{ color: '#989898', fontSize: '14px' }}>{item.name}</p>
                            </div>
                            <div className="applicable-slab-single-field-right" style={{ flex: 1 }}>
                                <div className="applicable-slab-single-field-components-wrapper" style={{ display: 'flex', gap: '10px'}}>
                                    {
                                        item.components.map(({ type, props }:{type:string,props:Record<string,any>},idx:number) => {
                                            const Ele = mappings[type]
                                            return <Ele 
                                                    key={props.name ?? `applicable-slab-single-field `+ idx}
                                                    {...props} 
                                                    onWheel={(e:ChangeEvent<HTMLInputElement>) => e.target.blur()}
                                                    size={"small"} 
                                                    onChange={handleChange}
                                                    disabled={!slab?.isEdit}
                                                    value={slab[props.name]}
                                                    {...(errors[props.name] && { error: true, helperText: errors[props.name] })}
                                                />;
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
        </div>
    )
}

export default SingleSlab